module.exports = __webpack_public_path__ + "img/banner-pc.184e11e6.jpg";